
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"matrix(2,0,0,2,0,0)"}},[_c('path',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","d":"M12 23.25C18.2132 23.25 23.25 18.2132 23.25 12C23.25 5.7868 18.2132 0.75 12 0.75C5.7868 0.75 0.75 5.7868 0.75 12C0.75 18.2132 5.7868 23.25 12 23.25Z"}}),_c('path',{attrs:{"fill":"none","stroke":"currentColor","stroke-width":"1.5","d":"M8.25 9.375C8.04289 9.375 7.875 9.20711 7.875 9C7.875 8.79289 8.04289 8.625 8.25 8.625"}}),_c('path',{attrs:{"fill":"none","stroke":"currentColor","stroke-width":"1.5","d":"M8.25 9.375C8.45711 9.375 8.625 9.20711 8.625 9C8.625 8.79289 8.45711 8.625 8.25 8.625"}}),_c('path',{attrs:{"fill":"none","stroke":"currentColor","stroke-width":"1.5","d":"M15.75 9.375C15.5429 9.375 15.375 9.20711 15.375 9C15.375 8.79289 15.5429 8.625 15.75 8.625"}}),_c('path',{attrs:{"fill":"none","stroke":"currentColor","stroke-width":"1.5","d":"M15.75 9.375C15.9571 9.375 16.125 9.20711 16.125 9C16.125 8.79289 15.9571 8.625 15.75 8.625"}}),_c('path',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","d":"M18.048 15C17.4894 16.1273 16.627 17.076 15.5581 17.7394C14.4891 18.4027 13.2561 18.7542 11.998 18.7542C10.7399 18.7542 9.50691 18.4027 8.43793 17.7394C7.36896 17.076 6.50656 16.1273 5.948 15"}})])])
          )
        }
      }
    